export default "images/other.png";